import styled from "styled-components";

export const Content = styled.div`
    width: 100%;
    margin-top: 1rem;
    overflow-y: auto;
    font-family: 'Inter', sans-serif;
    min-height: 80%;
    max-height: 80%;

    ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    ::-webkit-scrollbar-track {
        background: #c0c0c0;
        border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #ffffff;
        border-radius: 10px;
        border: 2px solid #c0c0c0;
    }
`;

export const BlurBackground = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    backdrop-filter: blur(3px);
    background-color: rgba(0, 0, 0, 0.4); 
    z-index: 1000;
    display: flex; 
    justify-content: center; 
    align-items: center;
`;